module.exports = __webpack_public_path__ + "img/smartWireless-1.1d397a7a.png";